query UsersList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: UsersFilterInput
) {
  users(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      email
      phone
      firstName
      lastName
      middleName
      displayName
      isAdmin
      isSuperAdmin
      isPartner
      isPlatformAdmin
      platformId
      platform {
        id
        title
      }
      currentOrganizationId
      currentOrganization {
        id
        title
      }
      createdAt
      updatedAt
      deletedAt
      deleted
    }
    count
  }
}
